/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_My_Dashboard_SubtitleInputs */



/**
* | output |
* | --- |
* | "Track your personal AI usage and activity" |
*
* @param {Dashboard_My_Dashboard_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_my_dashboard_subtitle = /** @type {((inputs?: Dashboard_My_Dashboard_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_My_Dashboard_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verfolge deine persönliche KI-Nutzung und Aktivitäten")
	return /** @type {LocalizedString} */ ("Track your personal AI usage and activity")
});